import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

function getScroller(): HTMLElement | null {
  return document.getElementById('app-scroll');
}

export function useAlwaysScrollTop(options?: { enabled?: boolean }) {
  const { enabled = true } = options ?? {};
  const { key } = useLocation();
  const navType = useNavigationType();

  // Disable the browser's native scroll restoration
  useEffect(() => {
    const prev = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
    return () => {
      window.history.scrollRestoration = prev;
    };
  }, []);

  // Scroll to the top on every route change
  useEffect(() => {
    if (!enabled) return;
    let frameId = 0;
    const scrollUp = () => {
      const el = getScroller();
      if (el) {
        el.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }
    };
    // Wait until the next frame in case the layout isn't mounted yet
    frameId = requestAnimationFrame(scrollUp); // scrollUp right before the next repaint
    return () => cancelAnimationFrame(frameId);
  }, [key, navType, getScroller, enabled]);
}
